import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import ColorsFilter from 'components/essentials/ColorsFilter';

const PDPUpholsteryColorFilters = ({
  activeColorFilters,
  showMobileColorFilter = false,
  showRowInMobile = false,
  toggleColorFilter,
}) => {
  const colors = useMemo(
    () =>
      activeColorFilters.reduce(
        (acc, item) => ({
          ...acc,
          [item]: true,
        }),
        {}
      ),
    [activeColorFilters]
  );

  return (
    <ColorsFilter
      colors={[
        'beige/white',
        'black',
        'blue',
        'brown',
        'green',
        'gray',
        'orange',
        'pink',
        'red',
        'white',
        'yellow',
      ]}
      onSelectColor={toggleColorFilter}
      selectedColors={colors}
      showRowInMobile={showRowInMobile}
      showMobileColorFilter={showMobileColorFilter}
    />
  );
};

PDPUpholsteryColorFilters.propTypes = {
  activeColorFilters: PropTypes.array,
  toggleColorFilter: PropTypes.func,
  showRowInMobile: PropTypes.bool,
  showMobileColorFilter: PropTypes.bool,
};

export default PDPUpholsteryColorFilters;
